/**
 * @generated SignedSource<<2599ccf20907658c8c3ce00be399429f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BrandLocations_brand$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"LocationsList_brand" | "LocationsMap_brand">;
  readonly " $fragmentType": "BrandLocations_brand";
};
export type BrandLocations_brand$key = {
  readonly " $data"?: BrandLocations_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"BrandLocations_brand">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BrandLocations_brand",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocationsList_brand"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LocationsMap_brand"
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};

(node as any).hash = "3e312718d68705bed9be5318a5e9dc1e";

export default node;
